module.exports = __webpack_public_path__ + "assets/img/28_977.d669cef6.jpg";